import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import SAInputLabel from "../common/input/SAInputLabel";
import SADropdown from "../common/dropdown/SADropdown";
import SAInputDistance from "../common/input/SAInputDistance";
import {Card} from "antd";
import * as types from "../../constants/ActionTypes";
import {fetchLeasingCompanies} from "../../actions/leasingCompaniesActions";
import {getGeneralInformation} from "../../selectors/createAppointmentRequest";
import {getFormattedLeasingCompanies} from "../../selectors/leasingCompanies";

class GeneralInformation extends React.Component {

  componentDidMount = () => {
    this.props.dispatchFetchLeasingCompanies();
  }

  onGeneralInformationChange = (value) => {
    this.props.dispatchSaveGeneralInformation({...value});
  };

  render = () => {
    const {generalInformation, leasingCompanies, mandatoryList} = this.props;

    return (
      <Card title={<h3><FormattedMessage id="call.center.journey.vehicle.title"/></h3>} bordered={false} style={{width: '100%'}}>
        <div className="wrap">
          <div className="content">
            <div className="row">
              <div className="col-4 form-field">
                <label htmlFor="birthDateLabel">
                  <FormattedMessage id="customer.journey.step.generalInformation.leasingCompany"/>
                </label>
                <SADropdown
                  name={'leasingCompany'}
                  value={generalInformation.leasingCompany}
                  choices={leasingCompanies}
                  onChange={(e) => this.onGeneralInformationChange({leasingCompany: e.target.value})}
                  style={{
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    height: '3.2rem',
                    backgroundPosition: 'right center'
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-8 form-field">
                <SAInputLabel
                  name={'licensePlate'}
                  value={generalInformation.licensePlate}
                  onChange={(e) => this.onGeneralInformationChange({licensePlate: e.target.value})}
                  label={'summary.license-plate'}
                  maxLength={15}
                  error={(!mandatoryList || mandatoryList.includes('licensePlate')) && !generalInformation.licensePlate ? {message: 'error.not.null'} : null}
                />
              </div>
              <div className="col-4 form-field">
                <label htmlFor="birthDateLabel">
                  <FormattedMessage id="customer.journey.step.generalInformation.mileage"/>
                </label>
                <SAInputDistance
                  value={generalInformation.mileage}
                  onChange={(mileage) => this.onGeneralInformationChange({mileage})}
                  min={0}
                  step={100}
                  defaultValue={0}
                  formatter={value => `${value}Km`}
                  error={(!mandatoryList || mandatoryList.includes('mileage')) &&!generalInformation.mileage ? {message: 'error.not.null'} : null}
                  style={{
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    width: '100%'
                  }}
                />
              </div>
              <div className="col-6 form-field">
                <SAInputLabel
                  name={'Model'}
                  value={generalInformation.model}
                  onChange={(e) => this.onGeneralInformationChange({model: e.target.value})}
                  label={'vehicle.model'}
                  maxLength={15}
                  error={(!mandatoryList || mandatoryList.includes('model')) && !generalInformation.model ? {message: 'error.not.null'} : null}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchLeasingCompanies: () => dispatch(fetchLeasingCompanies()),
  dispatchSaveGeneralInformation: (params) => dispatch({type: types.SAVE_GENERAL_INFORMATION, params})
});

const mapStateToProps = state => ({
  leasingCompanies: getFormattedLeasingCompanies(state),
  generalInformation: getGeneralInformation(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation);



// WEBPACK FOOTER //
// ./src/components/call-center/GeneralInformation.js